module.exports = __webpack_public_path__ + "static/img/h3.50c2ea3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h3.gif
// module id = qQbg
// module chunks = 1